import { ReplaySubject } from 'rxjs';

type ValuesOf<T> = T[keyof T];

export type ABTestTaskListType = keyof typeof abTestList;
export type HeaderMainGroupType = ValuesOf<{
  [K in keyof typeof abTestList]: typeof abTestList[K]['headerMainGroup'];
}>;
export type ABVariantsType = ValuesOf<{
  [K in keyof typeof abTestList]: ValuesOf<typeof abTestList[K]['abTestGroupIds']>;
}>;

export type ABTestItem<K extends keyof typeof abTestList> = {
  nameOfTask?: ABTestTaskListType;
  alias?: string;
  headerMainGroup: HeaderMainGroupType;
  stag: string;
  abTestVariants: ABVariantsType[];
  abTestGroupIds: Record<keyof typeof abTestList[K]['abTestGroupIds'], ABVariantsType>;
  resolvedValue?: ABVariantsType;
  resolvedValue$?: ReplaySubject<ABVariantsType>;
  resolvedCookieValue?: ABVariantsType;
  syncOnAuth?: boolean;
  debug?: boolean;
};

export type ABTestItemMok = {
  nameOfTask?: string;
  alias?: string;
  headerMainGroup: string;
  stag: string;
  abTestVariants: string[];
  abTestGroupIds: Record<string, string>;
  resolvedValue?: string;
  resolvedValue$?: ReplaySubject<string>;
  resolvedCookieValue?: string;
  syncOnAuth?: boolean;
  debug?: boolean;
};

export const AB_TEST_LIST: {
  [K in keyof typeof abTestList]: ABTestItem<K>;
} = {} as any;

export const abTestList = {
  'XXX': {
    alias: 'XXX',
    headerMainGroup: 'XXX1',
    abTestGroupIds: {
      V1: 'XXX1',
      V2: 'XXX2',
    },
    syncOnAuth: true,
    debug: true,
  }
} as const;
